import styled from 'styled-components';

interface ICaret {
    animate: boolean;
    disabled: boolean;
}
export const SCCaretIcon = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    height: auto;
`;
export const SCSvgRoot = styled.svg`
    fill-rule: evenodd;
    clip-rule: evenodd;
    stroke-linejoin: round;
    stroke-miterlimit: 2;
    width: 100%;
    height: 100%;
`;
export const SCCaret = styled.path<ICaret>`
    fill: ${(props): string =>
        props.animate === true
            ? props.disabled
                ? `rgba(100, 100, 104, 0.5)`
                : `rgba(8,124,171, 1)`
            : props.disabled
            ? `rgba(25, 48, 98, 0.5)`
            : `rgba(25, 48, 98, 1)`};
    transition: fill 0.25s ease-out;
`;
